import { Password } from '@mui/icons-material'
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import { LoadingButton } from '@mui/lab';
import { Box, FormGroup, InputAdornment, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useFocusInputs } from '../../../hooks/useFocusInputs';
import { useForm } from '../../../hooks/useForm';
import { useNotification } from '../../../hooks/useNotification';
import { useTranslation } from 'react-i18next';
import { useApiResolver } from '../../../hooks/useApiResolver';
import LoadingOverlay from '../../../components/others/LoadingOverlay';

const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;

export const FormNewPassword = ({ authData }) => {
    const { t } = useTranslation();
    const [sendNotification] = useNotification();
    const { resolveValue } = useApiResolver();
    const navigate = useNavigate();
    const {
        creatingNewPassword,
        handleCreateNewPassword,
        handleSetUserRestore,
        tokenTemporal
    } = authData;

    const [{ newPassword, confirmNewPassword }, handleInputChange] = useForm({
        newPassword: '',
        confirmNewPassword: ''
    });
    const [{ isNewPasswordFocus, isConfirmNewPasswordFocus }, handleFocusInputs] = useFocusInputs({
        isNewPasswordFocus: false,
        isConfirmNewPasswordFocus: false
    });

    const [errorNewPasword, setErrorNewPasword] = useState({
        isError: false,
        messageError: ''
    });
    const [errorConfirmPasword, setErrorConfirmPasword] = useState({
        isError: false,
        messageError: ''
    });

    const { token } = useParams();
    const [status, setStatus] = useState('loading');
    const [temporaryToken, setTemporaryToken] = useState('');

    useEffect(() => {
        if (token === '_') {
            setStatus('succes');
            setTemporaryToken(tokenTemporal);
            return;
        }

        const validateRegistration = async () => {
            const config = {
                method: 'POST',
                url: baseUrlFlow,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic OTAwMTE0MDk4OnNlYnlIcFdZcWlZM0RIVllsODhjWmFYaVNNSlNCZ0VrOXFDNU9SUUJlNUFyZk01NU95MTRWZUY2eGsyczcyOTA=`
                },
                data: JSON.stringify({
                    id_flow: "900114098-API-GENERATE_TEMPORAL_SESSION-RESTORE_PASSWORD",
                    token: token,
                })
            };
            const { data, status } = await resolveValue(config, false);
            if (status === 200) {
                handleSetUserRestore(data.user_name);
                if (data.status_token === 'INVALIDO') {
                    setTimeout(() => navigate(`/login/recoverPassword/${data.user_name}`), 1500);
                }
                else {
                    setTemporaryToken(data.token);
                    setStatus('succes');
                }
            }
        };

        validateRegistration();
    }, [navigate]);

    const handleSubmit = (e) => {
        e.preventDefault();

        //LA PASSWORD DEBE TENER UNA LONGITUD MINIMA DE 8 CARACTERES, DEBE CONTENER LO SIGUIENTE:
        //UNA MINUSCULA a-z, UNA MAYUSCULA A-Z, UN NUMERO 0-9, UNO DE LOS SIGUIENTES CARACTERES $ @ $ ! % * ? & +.
        const regex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&+])([A-Za-z\d$@$!%*?&]|[^ ]){8,15}$/);
        if (!newPassword) {
            setErrorNewPasword({
                isError: true,
                messageError: ''
            });
            return;
        }
        else if (!regex.test(newPassword)) {
            sendNotification({ msg: t("newPassword.passwordInfo"), variant: 'info' });
            setErrorNewPasword({
                isError: true,
                messageError: t("newPassword.passwordInvalid")
            });
            return;
        }
        else {
            setErrorNewPasword({
                isError: false,
                messageError: ''
            })
        }

        if (newPassword !== confirmNewPassword) {
            setErrorConfirmPasword({
                isError: true,
                messageError: t("newPassword.passwordMismatch")
            });
            return;
        }
        else
            setErrorConfirmPasword({
                isError: false,
                messageError: ''
            })
        handleCreateNewPassword(temporaryToken, newPassword);
        sendNotification({ msg: t("newPassword.passwordUpadeSucces"), variant: 'info' });
    }

    const handleFocus = (e) => handleFocusInputs(e);
    const handleClickBack = (e) => navigate("/");

    if (status === 'loading') {
        return <LoadingOverlay
            isOpen={true}
            text={'Verificando información...'}
        />
    }

    return (
        <>
            <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                flexDirection="row"
                marginBottom="1.4rem"
            >
                <LoadingButton
                    className='custom-button-back-zd-nx'
                    onClick={handleClickBack}
                    variant="contained"
                    type="submit"
                    size="small"
                    fullWidth
                    style={{ borderRadius: "20px", backgroundColor: (theme) => theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.main }}
                >
                    <ArrowCircleLeftOutlinedIcon
                        className="pointer"
                        fontSize="small"
                        color="#ffffff"
                        sx={{ marginRight: "6px" }}

                    />
                    {t("back")}
                </LoadingButton>
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="flex-start"
                flexDirection="column"
                sx={{ mb: 2, textAlign: 'left' }}
            >
                <Typography
                    color="#ffffff"
                    variant="h6"
                    sx={{ fontFamily: 'Afacad Flux Light', fontSize: '4rem', textAlign: 'left', lineHeight: '39px' }}
                >
                    {t("newPassword.newPassword").split("|")[0]}
                </Typography>
                <Typography
                    color="#ffffff"
                    variant="h6"
                    sx={{ fontFamily: 'Afacad Flux Black', fontSize: '4.25rem', textAlign: 'left', lineHeight: '1', marginBottom: '30px' }}
                >
                    {t("newPassword.newPassword").split("|")[1]}
                </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
                <FormGroup sx={{ my: 2, marginBottom: '36px' }}>
                    <TextField
                        className="custom-btn-zd-nix"
                        error={errorNewPasword.isError}
                        color={(isNewPasswordFocus) ? "text" : (errorNewPasword.isError) ? "error" : "text"}
                        label={t("newPassword.newPasswordLabel")}
                        type={'password'}
                        variant="outlined"
                        name="newPassword"
                        size="small"
                        autoComplete="off"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Password color={(isNewPasswordFocus) ? "text" : (errorNewPasword.isError) ? "error" : "text"} sx={{ fill: '#6728AF' }} />
                                </InputAdornment>
                            )
                        }}
                        value={newPassword}
                        helperText={errorNewPasword.messageError}
                        onChange={handleInputChange}
                        onFocus={handleFocus}
                        onBlur={handleFocus}
                    />
                </FormGroup>
                <FormGroup>
                    <TextField
                        className="custom-btn-zd-nix"
                        error={errorConfirmPasword.isError}
                        color={(isConfirmNewPasswordFocus) ? "text" : (errorConfirmPasword.isError) ? "error" : "text"}
                        label={t("newPassword.confirmNewPasswordLabel")}
                        type={'password'}
                        variant="outlined"
                        name="confirmNewPassword"
                        size="small"
                        autoComplete="off"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Password color={(isConfirmNewPasswordFocus) ? "text" : (errorConfirmPasword.isError) ? "error" : "text"} sx={{ fill: '#6728AF' }} />
                                </InputAdornment>
                            )
                        }}
                        value={confirmNewPassword}
                        helperText={errorConfirmPasword.messageError}
                        onChange={handleInputChange}
                        onFocus={handleFocus}
                        onBlur={handleFocus}
                    />
                </FormGroup>

                <LoadingButton
                    loading={creatingNewPassword}
                    variant="contained"
                    type="submit"
                    size="small"
                    fullWidth
                    style={{ borderRadius: "11px", paddingTop: "6px", marginTop: "1.5rem", backgroundColor: (theme) => theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.main }}
                >
                    {t("newPassword.createNewPassword")}
                </LoadingButton>
            </form>
        </>
    )
}